// Equivalências didáticas de CO₂ + microcopy ESG (Fase 0 — Vitrine Verde, PO1-2402).
// Converte o total de emissão MEDIDA do período em comparações do dia a dia.
// Fatores de fonte oficial reconhecida (citados em FONTE_EQUIVALENCIAS).
// Tom obrigatório: "pegada medida/transparente", NUNCA "neutro"/"compensado".

// kg CO₂ absorvidos por 1 árvore madura em 1 ano (US EPA, ~48 lb/ano).
export const KG_CO2_POR_ARVORE_ANO = 21.77;
// t CO₂ emitidas por 1 veículo de passeio em 1 ano (US EPA).
export const T_CO2_POR_CARRO_ANO = 4.6;
// t CO₂ por passageiro em 1 voo GRU–JFK (ida, econômica) — ICAO Carbon Emissions Calculator.
export const T_CO2_POR_VOO_GRU_JFK = 1.0;
// kg CO₂ por litro de gasolina queimado (US EPA: 8,887 kg/galão ÷ 3,78541 L/galão).
export const KG_CO2_POR_LITRO_GASOLINA = 2.3477;

// Copy padrão para PDF, CSV e card PNG.
export const TITULO_ESG = "Pegada de carbono medida";
export const SUBTITULO_ESG = "Transporte transparente · Everlog";
export const FONTE_EQUIVALENCIAS =
  "Fatores de emissão: base Everlog por modal. Equivalências: US EPA (árvores/veículos/gasolina) e ICAO (voo GRU-JFK). Estimativas para fins de comunicação.";

// Recebe o total de emissão do período em toneladas de CO₂ e devolve as três
// equivalências (inteiros — são comparações didáticas). Base = data.kpis.totalToneladasCO2.
export function calcularEquivalencias(totalToneladasCO2) {
  const t = Number(totalToneladasCO2) || 0;
  const kg = t * 1000;
  return {
    arvores: Math.round(kg / KG_CO2_POR_ARVORE_ANO),
    carros: Math.round(t / T_CO2_POR_CARRO_ANO),
    voos: Math.round(t / T_CO2_POR_VOO_GRU_JFK),
    gasolina: Math.round(kg / KG_CO2_POR_LITRO_GASOLINA),
  };
}

// Rótulos legíveis de cada equivalência (para tiles/relatório/card).
export const EQUIVALENCIA_LABELS = {
  arvores: "árvores absorvendo por 1 ano",
  carros: "carros de passeio rodando por 1 ano",
  voos: "voos São Paulo-Nova York (por passageiro)",
  gasolina: "litros de gasolina queimados",
};

// Nota de cobertura exibida sempre que houver números externos (anti-greenwashing).
// Retorna null quando não há CT-es no recorte (sem denominador confiável).
export function notaCobertura(cobertura) {
  if (!cobertura || !cobertura.totalCtes) return null;
  const pct = Number(cobertura.percentual) || 0;
  const fmtInt = (n) => Number(n || 0).toLocaleString("pt-BR");
  const fmtPct = pct.toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return `Baseado em ${fmtPct}% dos CT-es do período com pegada calculada (${fmtInt(
    cobertura.ctesCalculados
  )} de ${fmtInt(cobertura.totalCtes)}).`;
}
